<style lang="scss" scoped>
.market-block {
  width: 100%;
  overflow: hidden;

  .wrapper {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 1020px;
    margin: 0 auto;

    @include media(max, md) {
      max-width: 400px;
      position: relative;
    }

    @include media(max, lg) {
      padding: 0 15px;
      max-width: 600px;
    }

    .content {
      z-index: 10;
      max-width: 555px;
      padding-left: 45px;

      @include media(max, lg) {
        max-width: 60%;
        padding-left: 25px;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          top: -100px;
          z-index: -1;
          left: 0;
          right: 0;
          height: 155px;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, #000000 100%);
        }
      }

      @include media(max, md) {
        max-width: 100%;
        padding-left: 0;
        margin-top: 225px;
        text-align: left;
      }


      .text {
        margin-top: 22px;
        font-size: 18px;
        line-height: 1.6;
        color: #C3C3C3;
        margin-bottom: 20px;

        @include media(max, lg) {
          font-size: 16px;
        }

        @include media(max, md) {
          font-size: 18px;
        }

        p + p {
          margin-top: 10px;
        }
      }
      .link {
        font-size: 20px;
        color: $link-color-blue;

        &:after {
          content: '→';
          font-family: Arial, Helvetica;
          margin-left: 5px;
        }

        &:hover {
          color: $link-hover-color-blue;
        }

        &:active {
          color: $link-active-color-blue;
        }

        [dir=rtl] & {
          &:after {
            content: none;
          }

          &:before {
            content: '←';
            margin-left: 0;
            margin-right: 5px;
          }
        }
      }
    }

    .image {
      flex-basis: 100%;

      @include media(max, md) {
        position: absolute;
        left: 15px;
        right: 15px;
        top: 0;
        text-align: center;
      }

      img {
        @include media(max, md) {
          width: 100%;
          max-width: 350px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="market-block" id="market-block">
    <div class="wrapper">
      <div class="image">
        <img :src="`${baseUrl}images/about/market.png`"/>
      </div>
      <div class="content">
        <div class="title title_section" v-html="$t('title')"></div>
        <div class="text">
          <p>
            {{$t('description1')}}
          </p>
          <p>{{$t('description2')}}</p>
        </div>
        <a class="link" href="https://market.vkplay.ru/ " target="_blank">{{$t('link')}}</a>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'MarketBlock',
  i18n: {
    messages: {
      ru: {
        title: 'Покупайте и&nbsp;продавайте',
        link: 'Перейти',
        description1: 'Следите за новинками, выбирайте и покупайте предметы из любимой игры.',
        description2: 'Надёжно и безопасно оплачивайте покупки удобным для вас способом.',
      },
      en: {
        title: 'Buy and Sell',
        link: 'Explore',
        description1: 'Explore new items and content for your favorite games.',
        description2: 'Safely and easily pay for purchases with the most convenient payment methods.',
      },

      de: {
        title: 'Kaufen und verkaufen',
        link: 'Los',
        description1: 'Bleib über Neuerscheinungen auf dem Laufenden und erwirb ausgewählte Gegenstände von deinen Lieblingsspielen.',
        description2: 'Nutze für deine Käufe die sichere, zuverlässige und praktische Zahlmethode.',
      },

      fr: {
        title: 'Achetez et vendez',
        link: 'Accéder',
        description1: 'Soyez au courant des dernières nouveautés et achetez des objets de votre jeu favori.',
        description2: 'Payez vos achat de manière simple, sûre et pratique.',
      },
      es: {
        title: 'Comprar y vender',
        link: 'Ir Tienda',
        description1: 'Estate al corriente de las novedades, selecciona y elige artículos de tu juego favorito.',
        description2: 'Paga de forma sencilla, segura y sin riesgos.',
      },
      tr: {
        title: 'Al ve Sat',
        link: 'Git',
        description1: 'Yeni çıkanlardan haberdar ol ve favori oyunundan eşyalar seç ve al.',
        description2: 'Satın almalarını emniyetli, güvenilir ve uygun bir yolla öde.',
      },

      pl: {
        title: 'Kupuj i sprzedawaj',
        link: 'Idź',
        description1: 'Bądź na bieżąco z nowościami oraz wybieraj i kupuj przedmioty ze swojej ulubionej gry.',
        description2: 'Płać za zakupy w bezpieczny, niezawodny i wygodny sposób.',
      },
      ar: {
        title: 'البيع والشراء',
        link: 'استكشاف',
        description1: 'استكشف المحتوى والعناصر الجديدة لألعابك المفضلة.',
        description2: 'ادفع بسهولة وأمان لمشترياتك بأكثر الوسائل المريحة للدفع.',
      },
    },
  },
};

</script>
